import { getElements } from '../Utility/Dom'

class CssPreloadingService {
  init(): void {
    const linkTagsToPreload: NodeListOf<HTMLLinkElement> = getElements('preloaded-style') as NodeListOf<HTMLLinkElement>

    linkTagsToPreload.forEach((linkTagToPreload: HTMLLinkElement) => {
      linkTagToPreload.rel = 'stylesheet'
    })
  }
}

export default CssPreloadingService
